import React from 'react'
import { Helmet } from 'react-helmet'

const defaultOgImage = 'https://www.wagetap.com/assets/img/og_image.png';
const TYPEKIT_URL = 'https://use.typekit.net/vsx4skg.css';

/**
 * @param{{
 *  title: string,
 *  description: string,
 *  blogName: string,
 *  siteUrl: string,
 *  imageUrl?: string,
 *  blogPost?: boolean,
 *  authorTwitterUsername?: string,
 * }} props
 */
export default (props) => {
  checkExists(props.title, "title");
  checkExists(props.description, "description");
  checkExists(props.blogName, "blogName");
  checkExists(props.siteUrl, "siteUrl");

  const twitterHandle = props.authorTwitterUsername
      ? toTwitterHandle(props.authorTwitterUsername) : "@wagetap";

  return (
    <Helmet
      titleTemplate={(props.blogName && props.blogName !== props.title
            ? `%s | ${props.blogName}` : undefined)}
      defaultTitle={props.blogName}
      htmlAttributes={{ lang: 'en' }}
    >
      <title itemProp="name" lang="en">{props.title}</title>
      <meta property="og:title" content={props.title} />
      <meta name="twitter:title" content={props.title}/>

      <meta name="description" content={props.description}/>
      <meta property="og:description" content={props.description} />
      <meta property="twitter:description" content={props.description} />

      <meta property="og:site_name" content={props.blogName}/>
      <meta property="og:image" content={props.imageUrl || defaultOgImage} />
      <meta name="twitter:image" content={props.imageUrl || defaultOgImage}/>

      {props.blogPost ? (
        <meta property="og:type" content="article"/>
      ) : (
        <meta property="og:type" content="website"/>
      )}

      <meta name="og:url" content={props.siteUrl}/>
      <meta name="twitter:card" content="summary_large_image"/>
      <meta name="twitter:site" content="@wagetap"/>
      <meta name="twitter:creator" content={twitterHandle}/>
      <link rel="stylesheet" href={TYPEKIT_URL} />
      {props.children}
    </Helmet>
  );
}

function checkExists(value, name) {
  if (value == null) {
    throw new Error(`"${name}" cannot be empty`);
  }
}

function toTwitterHandle(username) {
  return username.startsWith('@') ? username : `@${username}`;
}
